import React from "react";
import style from "./textWithStatus.module.scss";
const TextWithStatus = ({ text, children, }) => {
    return (React.createElement(React.Fragment, null,
        text,
        React.createElement("div", { className: style["status"] }, children)));
};
export default TextWithStatus;
//# sourceMappingURL=TextWithStatus.js.map